<template>
    <div class="wrapper-bg">
        <div class="main-layout coffee-nofooter">
            <HeaderOther
                setTitle="Ready Brewed"
                :setHref="href"
                :showLogo="false"
            />
            <div class="amount-month">
                <div class="amount-header">Amount per Month</div>
                <ul class="amount-container">
                    <li
                        @click="clickAmountTab(item.name)"
                        class="amount-item"
                        :class="{ active: item.name === activeTab }"
                        v-for="item in amountItem"
                        :key="item.id"
                    >
                        <div class="name">{{ item.name }}</div>
                        <div class="price">
                            {{ item.price.toLocaleString() }} บาท
                        </div>
                    </li>
                </ul>
            </div>
            <div class="beverage-main" v-if="isLoaded">
                <div class="beverage-header">
                    <span>Beverage</span>
                    <span class="showmore" @click="showMore">ดูทั้งหมด</span>
                </div>
                <BeverageList
                    :beverage="coffeeList"
                    @setDefaultCup="setDefaultCup"
                />
            </div>
            <div
                class="upsize-main"
                v-if="
                    isLoaded && (sweetnessAll[activeTab] || extraAll[activeTab])
                "
            >
                <div v-if="sweetnessAll[activeTab]">
                    <div class="upsize-header">
                        ระดับความหวาน
                    </div>
                    <div class="sweetness-container">
                        <Sweetness
                            :defaultValue="defaultSweet"
                            :sweetness="sweetness"
                            @setSweetness="setSweetness"
                        />
                    </div>
                </div>
                <div v-if="extraAll[activeTab]">
                    <div class="upsize-header">
                        เพิ่มเติม
                    </div>
                    <ul class="checkbox-main">
                        <li
                            class="checkbox-container"
                            v-for="(item, index) in checkboxList"
                            :key="index"
                        >
                            <div
                                class="checkbox"
                                @click="toggleCheckbox(index)"
                            >
                                <img
                                    v-if="checkboxList[index].active === true"
                                    src="@/assets/campaignlist/checkmenu_active.svg"
                                    alt=""
                                />
                                <img
                                    v-else
                                    src="@/assets/campaignlist/checkmenu_inactive.svg"
                                    alt=""
                                />
                                <div class="item-name">{{ item.name }}</div>
                            </div>
                            <div class="item-price">{{ item.price }} บาท</div>
                        </li>
                    </ul>
                </div>
            </div>
            <Footer
                layout="black"
                text="ต่อไป"
                action="nextWithParams"
                path="packagedetail"
                :param="beverageObject"
                :total="stringPrice"
            ></Footer>
        </div>
    </div>
</template>

<script>
//mixin
import Mixin from "@/mixin/Mixin";
//components
import HeaderOther from "@/components/Header/HeaderOther.vue";
import Footer from "@/module/Subscription/components/Footer.vue";
import BeverageList from "@/module/Subscription/components/BeverageList.vue";
import Sweetness from "@/module/Subscription/components/Sweetness.vue";
//core
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/model/CampaignConfigModel.js";
import BzbsCampaign from "@/core/Campaign/service/BzbsCampaign.js";
//helper
import ConfigManager from "@/config/ConfigManager.js";
import Account from "@/helper/AccountHelper.js";
import Locale from "@/helper/locale/locale.js";
//vuex
import { mapGetters } from "vuex";

export default {
    name: "SubscriptionForm",
    components: {
        HeaderOther,
        Footer,
        BeverageList,
        Sweetness
    },
    props: {
        data: Object
    },
    mixins: [Mixin],
    data() {
        return {
            //finish loading
            isLoaded: false,

            activeTab: "20 แก้ว",
            //active tab list
            amountItem: [],
            //coffee list of all tab
            coffeeListAll: {},
            //copy list of coffee list
            coffeeFullList: [],
            //coffee list of activetab
            coffeeList: [],
            //active cup of coffee list
            defaultCup: "",
            sweetnessAll: {},
            extraAll: {},
            sweetness: [],
            defaultSweet: null,

            checkboxList: [],
            totalPrice: 0,
            stringPrice: "",

            beverageObject: {},

            //api config region
            listConfig: {},
            filterConfig: {},
            locale: Locale.getLocaleCode(),
            strBzbsToken: Account.getToken()
        };
    },
    computed: {
        ...mapGetters(["getUserSubscription"])
    },
    async created() {
        this.handleLoading(true);
        this.href =
            "subscriptiondetail/" +
            this.getUserSubscription.campaign.campaign.id;
        const SetConfig = await this.setConfig();
        const GetSubScription = await this.getSubscriptionItem();
        let beverage = this.getUserSubscription.detail.beverage;

        const getAddon = this.getAddonItem();
        const GetUpsize = this.getUpsizeItem();

        if (beverage) {
            this.activeTab = beverage.cupAmount.name;
            if (this.sweetnessAll[this.activeTab]) {
                this.defaultSweet = beverage.sweetness || 100;
                this.beverageObject["sweetness"] = this.defaultSweet;
                this.beverageObject["sweetnessCode"] = beverage.sweetnessCode;
            }
        }
        Promise.all([SetConfig, GetSubScription, getAddon, GetUpsize]).then(
            () => {
                let activeTabFilter = this.amountItem.filter(item => {
                    return item.name === this.activeTab;
                })[0];
                if (beverage && beverage.check) {
                    for (let i = 0; i < beverage.check.length; i++) {
                        this.checkboxList.map(item => {
                            if (beverage.check[i].name == item.name) {
                                item.active = true;
                            }
                        });
                    }
                    this.beverageObject["check"] = beverage.check;
                }
                this.coffeeList = [...this.coffeeListAll[this.activeTab]];
                this.beverageObject["cupAmount"] = activeTabFilter;
                this.setupCoffeeList();
                this.calculatePrice(activeTabFilter.price, "plus");
                //check upsize
                if (beverage) {
                    this.stringPrice !== beverage.totalPrice &&
                        this.calculatePrice(
                            beverage.totalPrice - this.stringPrice,
                            "plus"
                        );
                }
                this.isLoaded = true;
                this.handleLoading(false);
            }
        );
    },
    methods: {
        getAddonItem() {
            return new Promise(resolve => {
                let configStr = ConfigManager.getAddon();
                let listConfig = new CampaignListConfigBuilder()
                    .setConfigList(configStr)
                    .create();
                BzbsCampaign.apiGetCampaign(
                    this.strBzbsToken,
                    listConfig,
                    null
                ).subscribe(
                    campaigns => {
                        console.log(this.sweetnessAll[this.activeTab], !this.getUserSubscription.detail.beverage)
                        for (
                            let i = 0;
                            i < campaigns[0].subCampaigns.length;
                            i++
                        ) {
                            this.sweetness.push({
                                id: campaigns[0].subCampaigns[i].ID,
                                Name: campaigns[0].subCampaigns[i].Name * 100
                            });
                        }
                        if (
                            this.sweetnessAll[this.activeTab] &&
                            !this.getUserSubscription.detail.beverage
                        ) {
                            this.setSweetness(this.sweetness.find(item => item.Name === 100)[0]);
                        }
                        resolve(campaigns);
                    },
                    err => {
                        console.log(err);
                    }
                );
            });
        },
        getUpsizeItem() {
            return new Promise(resolve => {
                let extraTag = "";
                if (this.extraAll[this.activeTab]) {
                    extraTag = this.extraAll[this.activeTab].split(",");
                }
                let configStr = ConfigManager.getUpsize();
                let extraTagArray = [];
                for (let i = 0; i < extraTag.length; i++) {
                    extraTagArray.push(extraTag[i]);
                }
                let listConfig = new CampaignListConfigBuilder()
                    .setConfigList(configStr)
                    .setTags(extraTagArray)
                    .create();

                this.checkboxList = [];
                if (extraTag === "") {
                    resolve(this.checkboxList);
                } else {
                    this.checkboxList = [];
                    BzbsCampaign.apiGetCampaign(
                        this.strBzbsToken,
                        listConfig,
                        null
                    ).subscribe(
                        campaigns => {
                            for (let i = 0; i < campaigns.length; i++) {
                                this.checkboxList.push({
                                    id: campaigns[i].subCampaigns[0].ID,
                                    name: campaigns[i].name,
                                    price: campaigns[i].pricePerUnit,
                                    active: false
                                });
                            }
                            resolve(this.checkboxList);
                        },
                        err => {
                            console.log(err);
                        }
                    );
                }
            });
        },
        setConfig() {
            let configStr = ConfigManager.getSubscriptionItem();
            let listConfig = new CampaignListConfigBuilder()
                .setConfigList(configStr)
                .setCatId(this.getUserSubscription.campaign.campaign.id)
                .setByConfig(true)
                .create();
            this.listConfig = listConfig;
            let filterConfig = new CampaignListFilterConfigBuilder().create();
            this.filterConfig = filterConfig;
        },
        getSubscriptionItem() {
            return new Promise(resolve => {
                BzbsCampaign.apiGetCampaign(
                    this.strBzbsToken,
                    this.listConfig,
                    this.filterConfig
                ).subscribe(
                    campaigns => {
                        for (let i = 0; i < campaigns.length; i++) {
                            this.amountItem.push({
                                id: campaigns[i].id,
                                name: campaigns[i].name,
                                price: campaigns[i].pricePerUnit
                            });
                            this.coffeeListAll[`${campaigns[i].name}`] =
                                campaigns[i].subCampaigns;

                            if (
                                JSON.parse(campaigns[i].extra) &&
                                JSON.parse(campaigns[i].extra)
                                    .addons_config_list
                            ) {
                                for (
                                    let j = 0;
                                    j <
                                    JSON.parse(campaigns[i].extra)
                                        .addons_config_list.length;
                                    j++
                                ) {
                                    let addonConfig = JSON.parse(
                                        campaigns[i].extra
                                    ).addons_config_list;
                                    if (
                                        addonConfig[j].config ===
                                        "campaign_nescafestreet_subscription_addon"
                                    ) {
                                        this.sweetnessAll[
                                            `${campaigns[i].name}`
                                        ] = true;
                                    }
                                    if (
                                        addonConfig[j].config ===
                                        "campaign_nescafestreet_subscription_upsize"
                                    ) {
                                        this.extraAll[`${campaigns[i].name}`] =
                                            addonConfig[j].config_hashtag;
                                    }
                                }
                            } else {
                                this.sweetnessAll[
                                    `${campaigns[i].name}`
                                ] = false;
                            }
                        }
                        resolve(campaigns);
                    },
                    err => {
                        console.log(err);
                    }
                );
            });
        },
        setupCoffeeList() {
            this.coffeeFullList = [...this.coffeeList];
            this.coffeeList.splice(2, this.coffeeList.length - 2);
            if (this.data && this.data.Name !== this.coffeeList[0].Name) {
                this.coffeeList.splice(1, 1);
                this.coffeeList.unshift(this.data);
                this.beverageObject["defaultCup"] = this.data;
            }
            if (!this.data && this.getUserSubscription.detail.beverage) {
                let cupFilter = this.coffeeFullList.filter(item => {
                    return (
                        item.Name ===
                        this.getUserSubscription.detail.beverage.defaultCup
                    );
                })[0];
                if (cupFilter && cupFilter.Name !== this.coffeeList[0].Name) {
                    this.coffeeList.splice(1, 1);
                    this.coffeeList.unshift(cupFilter);
                }
            }
        },
        setDefaultCup(cup) {
            this.defaultCup = cup.Name;
            this.beverageObject["defaultCup"] = cup.Name;
            this.beverageObject["defaultCupCode"] = cup.ID;
        },
        setSweetness(sweetness) {
            this.beverageObject["sweetness"] = sweetness.Name;
            this.beverageObject["sweetnessCode"] = sweetness.id;
        },
        showMore() {
            this.$router.push({
                name: "allbeverage",
                params: {
                    data: this.coffeeListAll[this.activeTab],
                    beverage: this.beverageObject
                }
            });
        },
        clickAmountTab(tab) {
            // โลจิคเก่าในกรณีที่อยากเอาราคา addon ไปด้วยเวลากดเปลี่ยน tab
            // let activeTabFilter = this.amountItem.filter(item => {
            //     return item.name === this.activeTab;
            // })[0];
            // let activeTabPrice = activeTabFilter.price;

            let clickTabFilter = this.amountItem.filter(item => {
                return item.name === tab;
            })[0];
            this.beverageObject["cupAmount"] = clickTabFilter;

            let clickTabPrice = clickTabFilter.price;

            this.activeTab = tab;
            if (!this.sweetnessAll[this.activeTab]) {
                delete this.beverageObject.sweetness;
                delete this.beverageObject.sweetnessCode;
            } else {
                this.defaultSweet = 100;
                this.setSweetness(this.sweetness.find(item => item.Name == 100));
            }
            //get new chackboxlist
            this.getUpsizeItem();

            this.coffeeList = [...this.coffeeListAll[this.activeTab]];
            this.coffeeList.splice(2, this.coffeeList.length - 2);

            this.calculatePrice(clickTabPrice, "reset");

            // โลจิคเก่าในกรณีที่อยากเอาราคา addon ไปด้วยเวลากดเปลี่ยน tab
            // if (activeTabPrice > clickTabPrice) {
            //     let differentPrice = activeTabPrice - clickTabPrice;
            //     this.calculatePrice(differentPrice, "minus");
            // } else {
            //     let differentPrice = clickTabPrice - activeTabPrice;
            //     this.calculatePrice(differentPrice, "plus");
            // }
        },
        toggleCheckbox(index) {
            this.checkboxList[index].active = !this.checkboxList[index].active;
            if (this.checkboxList[index].active) {
                this.calculatePrice(this.checkboxList[index].price, "plus");
            } else {
                this.calculatePrice(this.checkboxList[index].price, "minus");
            }
            let filterCheckbox = this.checkboxList.filter(
                item => item.active == true
            );
            this.beverageObject["check"] = filterCheckbox;
        },
        calculatePrice(price, methods) {
            if (methods === "plus") {
                this.totalPrice += price;
            } else if (methods === "minus") {
                this.totalPrice -= price;
            } else if (methods === "reset") {
                this.totalPrice = price;
            }
            this.stringPrice = this.totalPrice.toString();
            this.beverageObject["totalPrice"] = this.stringPrice;
        }
    }
};
</script>

<style lang="scss" scoped>
$main-color: #a7907b;
ul {
    margin: 0;
}
.wrapper-bg {
    padding: 0;
    .amount-month {
        .amount-header {
            color: #fff;
            font-size: 16px;
            padding: 10px 20px;
        }
        .amount-container {
            display: flex;
            padding: 0 20px;
            justify-content: space-between;
            .amount-item {
                display: flex;
                align-items: center;
                justify-content: center;
                flex-direction: column;
                color: #fff;
                font-size: 16px;
                border: 1px solid $main-color;
                border-radius: 10px;
                background-color: rgba(167, 144, 123, 0.3);
                padding: 8px;
                width: 30%;
                height: 78px;
                .price {
                    text-align: center;
                    font-family: "PromptSemiBold";
                    font-size: 16px;
                }
                .name {
                    text-align: center;
                }
                &.active {
                    background-color: $main-color;
                }
            }
        }
    }
    .beverage-main {
        padding: 20px;
        .beverage-header {
            color: #fff;
            font-size: 16px;
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
            .showmore {
                text-decoration: underline;
            }
        }
    }
    .upsize-main {
        margin: 0 20px;
        margin-bottom: 18vh;
        padding: 8px 12px;
        color: #fff;
        background-color: #000;
        border-radius: 10px;
        .upsize-header {
            margin-bottom: 10px;
        }
        .sweetness-container {
            margin-bottom: 25px;
        }
        .checkbox-main {
            .checkbox-container {
                display: flex;
                justify-content: space-between;
                margin-bottom: 15px;
                .checkbox {
                    display: flex;

                    img {
                        margin-right: 5px;
                    }
                }
            }
        }
    }
}
</style>
